document.addEventListener('DOMContentLoaded', function () {
  const categoryButtons = document.querySelectorAll('.js-category-filter');
  const pillButtons = document.querySelectorAll('.js-pill');
  const gifCards = document.querySelectorAll('.js-gif-card');
    const searchInput = document.querySelector('.custom-search-bar__container input');
const suggestionList = document.querySelector('.search-suggestions-list');

  let activeCategory = '';
  let activePill = '';

  // ✅ Initialize Splide instance
  let splideInstance; 
  const splideEl = document.querySelector('#text-slider');
  if (splideEl && typeof Splide !== 'undefined') {
    splideInstance = new Splide(splideEl, {
      perPage: 6,
     
      gap: '16px',
      pagination: false,
      arrows: true,
      breakpoints: {
        768: { perPage: 4 },
        480: { 
          perPage: 4,
          gap: '10px'

        }
      }
    }).mount();
  }

  // 🔁 FILTER FUNCTION
  function filterCards() {
    gifCards.forEach(card => {
      const productCategory = card.dataset.productCategory?.trim().toLowerCase();
      const pillCategory = card.dataset.pillCategory?.trim().toLowerCase();

      const categoryMatch = productCategory === activeCategory;
      const pillMatch = activePill === '' || pillCategory === activePill;

      card.style.display = categoryMatch && pillMatch ? '' : 'none';
    });

    document.querySelectorAll('.custom-gif-card__section').forEach(section => {
      const cards = section.querySelectorAll('.js-gif-card');
      const anyVisible = Array.from(cards).some(card => card.style.display !== 'none');
      section.style.display = anyVisible ? '' : 'none';
    });
  }

  // 🔘 ACTIVATE CATEGORY
  function activateCategory(button) {
    searchInput.value = '';
  suggestionList.innerHTML = '';
    activeCategory = button.dataset.category?.trim().toLowerCase();
    const activeColor = button.dataset.activeColor || '#054A91';

    categoryButtons.forEach((btn, index) => {
      const match = btn.dataset.category?.trim().toLowerCase() === activeCategory;
      btn.classList.toggle('is-active', match);
      btn.style.backgroundColor = match ? activeColor : '#D2EAFF';
      btn.style.color = match ? '#fff' : '#000';

      // 🔄 Scroll to the category in Splide
      // ✅ Only scroll into view if the button is not fully visible
if (match) {
  const parent = btn.closest('.splide__track');
  const parentRect = parent?.getBoundingClientRect();
  const btnRect = btn.getBoundingClientRect();

  if (btnRect.left < parentRect.left || btnRect.right > parentRect.right) {
    btn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }
}

    });

    filterCards();
  }

  // 🎯 ACTIVATE PILL
  function activatePill(pill) {
    searchInput.value = '';
  suggestionList.innerHTML = '';
    activePill = pill.dataset.pillLabel?.trim().toLowerCase();
    const activeColor = pill.dataset.activeColor || '#054A91';

    pillButtons.forEach(btn => {
      const match = btn.dataset.pillLabel?.trim().toLowerCase() === activePill;
      btn.classList.toggle('is-active', match);
      btn.style.backgroundColor = match ? activeColor : 'transparent';
      btn.style.color = match ? '#fff' : '#000';
    });

    filterCards();
  }

  // 🖱️ EVENT LISTENERS
  categoryButtons.forEach(btn => {
    btn.addEventListener('click', () => activateCategory(btn));
  });

  pillButtons.forEach(pill => {
    pill.addEventListener('click', () => activatePill(pill));
  });

  // ✅ DEFAULT STATE
  if (categoryButtons.length) {
    activateCategory(categoryButtons[0]);
    const defaultPill = Array.from(pillButtons).find(p => p.dataset.pillLabel?.trim().toLowerCase() === 'sticker');
    if (defaultPill) activatePill(defaultPill);
  }

  // 📥 DOWNLOAD
  document.querySelectorAll('.custom-dwonload__icon').forEach(btn => {
    btn.addEventListener('click', () => {
      const img = btn.closest('.custom-gif-card__image__wrapper')?.querySelector('img');
      if (!img?.src) return;
      const link = document.createElement('a');
      link.href = img.src;
      link.download = img.src.split('/').pop().split('?')[0] || 'image.gif';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  });
// 📤 SHARE
document.querySelectorAll('.custom-share__icon').forEach(shareBtn => {
  shareBtn.addEventListener('click', () => {
    const card = shareBtn.closest('.js-gif-card');
    const img = card?.querySelector('img');
    const title = card?.querySelector('p')?.textContent?.trim() || 'Check this out!';

    const shareData = {
      title: document.title,
      text: title,
      url: img?.src || window.location.href
    };

    if (navigator.share) {
      navigator.share(shareData).catch(err => {
        console.warn('Sharing failed:', err);
      });
    } else {
      // Fallback: copy the image link
      navigator.clipboard.writeText(shareData.url)
        .then(() => alert('Link copied! Share it manually.'))
        .catch(() => alert('Could not copy. Please use a modern browser.'));
    }
  });
});

// 📋 Copy functionality with fallback and icon reset
document.querySelectorAll('.custom-copy__icon').forEach(btn => {
  btn.addEventListener('click', async () => {
    const img = btn.closest('.custom-gif-card__image__wrapper')?.querySelector('img');
    if (!img?.src) return showToast('❌ Image not found.');

    const originalIcon = btn.querySelector('.copy-icon__content')?.outerHTML || '';
    const successIconRaw = btn.dataset.successIcon;

    // Show loading spinner
    btn.innerHTML = `
      <div class="copy-spinner" style="
        width:20px;height:20px;border:2px solid #ccc;border-top:2px solid #333;
        border-radius:50%;animation:spin 1s linear infinite;margin:auto;"></div>`;

    try {
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

      const copied = isSafari
        ? await copyAsText(img.src)
        : await copyImageAsBlob(img.src) || await copyImageViaCanvas(img) || await copyAsText(img.src);

      if (copied) {
        showToast('✅ Copied to clipboard!');
        // Safely parse and insert success icon SVG
        btn.innerHTML = '';
        const iconEl = createHTMLFromString(successIconRaw);
        if (iconEl) btn.appendChild(iconEl);

        // Revert to original icon after delay
        setTimeout(() => {
          btn.innerHTML = originalIcon;
        }, 2000);
      } else {
        throw new Error('All copy methods failed.');
      }
    } catch (err) {
      console.error('Copy failed:', err);
      showToast('❌ Copy failed.');
      btn.innerHTML = originalIcon;
    }
  });
});

// ✅ Copy fallback for Safari
function copyAsText(text) {
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    const success = document.execCommand('copy');
    document.body.removeChild(textarea);
    return success;
  } catch {
    return false;
  }
}

// ✅ Copy using Blob (preferred)
async function copyImageAsBlob(url) {
  try {
    if (!navigator.clipboard || !window.ClipboardItem) return false;
    const res = await fetch(url, { mode: 'cors' });
    const blob = await res.blob();
    if (!blob.type.startsWith('image/')) return false;
    const item = new ClipboardItem({ [blob.type]: blob });
    await navigator.clipboard.write([item]);
    return true;
  } catch {
    return false;
  }
}

// ✅ Copy using Canvas (fallback)
async function copyImageViaCanvas(img) {
  try {
    const tempImg = new Image();
    tempImg.crossOrigin = 'anonymous';

    await new Promise((res, rej) => {
      tempImg.onload = res;
      tempImg.onerror = rej;
      tempImg.src = img.src;
    });

    const canvas = document.createElement('canvas');
    canvas.width = tempImg.width;
    canvas.height = tempImg.height;
    canvas.getContext('2d').drawImage(tempImg, 0, 0);

    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
    if (!blob) return false;

    const item = new ClipboardItem({ 'image/png': blob });
    await navigator.clipboard.write([item]);
    return true;
  } catch {
    return false;
  }
}

// ✅ Utility to show toast
function showToast(message) {
  const oldToast = document.querySelector('.custom-toast');
  if (oldToast) oldToast.remove();

  const toast = document.createElement('div');
  toast.className = 'custom-toast';
  toast.textContent = message;
  Object.assign(toast.style, {
    position: 'fixed',
    bottom: '2rem',
    left: '50%',
    transform: 'translateX(-50%)',
    background: message.includes('❌') ? '#dc3545' :
               message.includes('⚠️') ? '#ffc107' : '#28a745',
    color: '#fff',
    padding: '10px 20px',
    borderRadius: '6px',
    fontSize: '14px',
    zIndex: 9999,
    opacity: 0,
    transition: 'opacity 0.3s ease'
  });
  document.body.appendChild(toast);
  requestAnimationFrame(() => (toast.style.opacity = 1));
  setTimeout(() => {
    toast.style.opacity = 0;
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

// ✅ Utility to parse HTML string into DOM node
function createHTMLFromString(htmlString) {
  const template = document.createElement('template');
  template.innerHTML = htmlString.trim();
  return template.content.firstChild;
}

// ✅ Spinner animation
if (!document.getElementById('spin-style')) {
  const style = document.createElement('style');
  style.id = 'spin-style';
  style.textContent = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }`;
  document.head.appendChild(style);
}


  function showToast(message) {
  const toast = document.createElement('div');
  toast.className = 'custom-toast';
  toast.textContent = message;

  Object.assign(toast.style, {
    position: 'fixed',
    bottom: '2rem',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: '#rgb(101, 179, 6)',
    color: '#fff',
    padding: '10px 20px',
    borderRadius: '4px',
    fontSize: '14px',
    zIndex: 9999,
    opacity: 0,
    transition: 'opacity 0.3s ease'
  });

  document.body.appendChild(toast);
  requestAnimationFrame(() => {
    toast.style.opacity = 1;
  });

  setTimeout(() => {
    toast.style.opacity = 0;
    setTimeout(() => toast.remove(), 300);
  }, 2000);
}

  // 🧭 FILTER DRAWER (section aware)
  document.querySelectorAll('.custom-filter__container').forEach(openBtn => {
    const section = openBtn.closest('.custom-gif-card__section');
    const drawer = section?.querySelector('#gif-filter-drawer');
    const closeBtn = drawer?.querySelector('#gif-filter-close');
    const categoryList = drawer?.querySelector('#drawer-categories');
    const subcategoryList = drawer?.querySelector('#drawer-subcategories');

    if (!drawer || !closeBtn || !categoryList || !subcategoryList) return;

   openBtn.addEventListener('click', () => {
  drawer.classList.add('open');
  buildDrawer(categoryList, subcategoryList);
});


    closeBtn.addEventListener('click', () => {
      drawer.classList.remove('open');
    });
  });

  // 🧱 BUILD DRAWER: category > subcategories
function buildDrawer(categoryList, subcategoryList) {
  const cards = document.querySelectorAll('.js-gif-card');
  const categoriesMap = {};

  cards.forEach(card => {
    const category = card.dataset.productCategory?.trim();
    const subcategory = card.dataset.pillCategory?.trim();
    const title = card.querySelector('p')?.textContent?.trim();
    const image = card.querySelector('img');

    if (!image?.src || !category || !subcategory) return;

    if (!categoriesMap[category]) {
      categoriesMap[category] = {
        allMedia: [],
        subcategories: {}
      };
    }

    // ✅ Add to "All Media" if title is available
    if (title) {
      categoriesMap[category].allMedia.push({ title, subcategory });
    }

    // ✅ Always add subcategory
    if (!categoriesMap[category].subcategories[subcategory]) {
      categoriesMap[category].subcategories[subcategory] = new Set();
    }

    // Add title (optional, for counting later if needed)
    if (title) {
      categoriesMap[category].subcategories[subcategory].add(title);
    }
  });

  categoryList.innerHTML = '';

  if (Object.keys(categoriesMap).length === 0) {
    categoryList.innerHTML = `<p style="padding:1rem; color: #666;">No filter data available.</p>`;
    return;
  }

  Object.entries(categoriesMap).forEach(([category, data]) => {
    const categoryItem = document.createElement('div');
    categoryItem.className = 'drawer-category-item';

    const categoryHeader = document.createElement('div');
    categoryHeader.className = 'drawer-category-toggle';
    categoryHeader.style.cursor = 'pointer';
    categoryHeader.style.fontWeight = '600';
    categoryHeader.innerHTML = `<span>${category}</span>`;

    const contentWrapper = document.createElement('div');
    contentWrapper.className = 'drawer-category-content';
    contentWrapper.style.display = 'none';

    // 🔷 All Media Section
    if (data.allMedia.length > 0) {
      const allMediaHeader = document.createElement('div');
      allMediaHeader.className = 'drawer-subcategory-toggle';
      allMediaHeader.style = 'display: flex; justify-content: space-between; align-items: center; cursor: pointer; font-weight: 500; margin-top: 10px;';
      allMediaHeader.innerHTML = `<span>All Media</span><span class="toggle-icon">▼</span>`;

      const allMediaList = document.createElement('div');
      allMediaList.className = 'drawer-submedia-list';
      allMediaList.style.display = 'none';
      allMediaList.style.paddingLeft = '1rem';

      data.allMedia.forEach(({ title, subcategory }) => {
        const mediaItem = document.createElement('div');
        mediaItem.className = 'drawer-submedia-item';
        mediaItem.textContent = title;
        mediaItem.style = 'cursor: pointer; font-size: 14px; padding: 4px 0;';
        mediaItem.addEventListener('click', () => {
          activateCategoryByName(category);
          activatePillByName(subcategory);
          scrollToMediaByTitle(title);
          closeDrawer();
        });

        allMediaList.appendChild(mediaItem);
      });

      allMediaHeader.addEventListener('click', () => {
        const icon = allMediaHeader.querySelector('.toggle-icon');
        const isOpen = allMediaList.style.display === 'block';
        allMediaList.style.display = isOpen ? 'none' : 'block';
        icon.textContent = isOpen ? '▼' : '▲';
      });

      contentWrapper.appendChild(allMediaHeader);
      contentWrapper.appendChild(allMediaList);
    }

    // 🟩 Subcategory section (GIF, Sticker, Others)
    if (Object.keys(data.subcategories).length > 0) {
      const subcatHeader = document.createElement('div');
      subcatHeader.className = 'drawer-subcategory-toggle';
      subcatHeader.style = 'display: flex; justify-content: space-between; align-items: center; cursor: pointer; font-weight: 500; margin-top: 10px;';
      subcatHeader.innerHTML = `<span>Subcategories</span><span class="toggle-icon">▼</span>`;

      const subcatList = document.createElement('div');
      subcatList.className = 'drawer-subcategory-list';
      subcatList.style.display = 'none';
      subcatList.style.paddingLeft = '1rem';

      Object.keys(data.subcategories).forEach(subcat => {
        const subcatBtn = document.createElement('div');
        subcatBtn.className = 'drawer-subcategory-item';
        subcatBtn.textContent = subcat;
        subcatBtn.style = 'cursor: pointer; font-size: 14px; padding: 4px 0;';
        subcatBtn.addEventListener('click', () => {
          activateCategoryByName(category);
          activatePillByName(subcat);
          closeDrawer();
        });

        subcatList.appendChild(subcatBtn);
      });

      subcatHeader.addEventListener('click', () => {
        const icon = subcatHeader.querySelector('.toggle-icon');
        const isOpen = subcatList.style.display === 'block';
        subcatList.style.display = isOpen ? 'none' : 'block';
        icon.textContent = isOpen ? '▼' : '▲';
      });

      contentWrapper.appendChild(subcatHeader);
      contentWrapper.appendChild(subcatList);
    }

    categoryHeader.addEventListener('click', () => {
      contentWrapper.style.display = contentWrapper.style.display === 'none' ? 'block' : 'none';
    });

    categoryItem.appendChild(categoryHeader);
    categoryItem.appendChild(contentWrapper);
    categoryList.appendChild(categoryItem);
  });
}

function scrollToMediaByTitle(title) {
  const cards = document.querySelectorAll('.js-gif-card');
  const match = Array.from(cards).find(card =>
    card.querySelector('p')?.textContent?.trim().toLowerCase() === title.toLowerCase()
  );
  if (match) {
    match.scrollIntoView({ behavior: 'smooth', block: 'center' });
    match.classList.add('highlighted');
    setTimeout(() => match.classList.remove('highlighted'), 1500);
  }
}


function closeDrawer() {
  document.querySelectorAll('#gif-filter-drawer.open').forEach(drawer => {
    drawer.classList.remove('open');
  });
}


  // 🔍 Helper for programmatic activation
  function activateCategoryByName(category) {
    const match = Array.from(categoryButtons)
      .find(btn => btn.dataset.category?.trim().toLowerCase() === category.trim().toLowerCase());
    if (match) activateCategory(match);
  }

  function activatePillByName(pillLabel) {
    const match = Array.from(pillButtons)
      .find(btn => btn.dataset.pillLabel?.trim().toLowerCase() === pillLabel.trim().toLowerCase());
    if (match) activatePill(match);
  }


// Collect searchable data
let searchData = Array.from(gifCards).map(card => ({
  element: card,
  title: card.querySelector('p')?.textContent?.trim() || '',
  category: card.dataset.productCategory || '',
  pill: card.dataset.pillCategory || ''
}));
searchInput?.addEventListener('input', function () {
  const term = this.value.trim().toLowerCase();
  suggestionList.innerHTML = '';

  // ✅ Only skip if input is actually empty
  if (term === '') return;

  const seen = new Set();

  const filtered = searchData.filter(item => {
    return (
      item.title.toLowerCase().includes(term) ||
      item.category.toLowerCase().includes(term) ||
      item.pill.toLowerCase().includes(term)
    );
  });

  filtered.forEach(item => {
    // Title
    const gifKey = `title-${item.title}`;
    if (item.title && !seen.has(gifKey)) {
      seen.add(gifKey);
      const li = document.createElement('li');
      li.textContent = `${item.title} (Category: ${item.category})`;
      li.addEventListener('click', () => {
        activateCategoryByName(item.category);
        activatePillByName(item.pill);
        scrollToMediaByTitle(item.title);
        searchInput.value = item.title;
        suggestionList.innerHTML = '';
      });
      suggestionList.appendChild(li);
    }

    // Pill
    const subKey = `pill-${item.pill}-${item.category}`;
    if (item.pill && !seen.has(subKey)) {
      seen.add(subKey);
      const li = document.createElement('li');
      li.textContent = `Subcategory: ${item.pill} (Category: ${item.category})`;
      li.addEventListener('click', () => {
        activateCategoryByName(item.category);
        activatePillByName(item.pill);
        searchInput.value = item.pill;
        suggestionList.innerHTML = '';
      });
      suggestionList.appendChild(li);
    }

    // Category
    const catKey = `cat-${item.category}`;
    if (item.category && !seen.has(catKey)) {
      seen.add(catKey);
      const li = document.createElement('li');
      li.textContent = `Category: ${item.category}`;
      li.addEventListener('click', () => {
        activateCategoryByName(item.category);
        searchInput.value = item.category;
        suggestionList.innerHTML = '';
      });
      suggestionList.appendChild(li);
    }
  });
});

});
